import React from 'react'
import './Articles.css'
import ArticlesCard from '../articles_card/ArticlesCard'
import articles from '../../const/articles'
export default function Articles() {
    return (
        <div id="articles" className="articles">
            <h4>Articles</h4>
            <div className="articles-cards-container">
            { articles.map(el=> <ArticlesCard key={el.id} card={el}/>)}
            </div>
        </div>
    )
}
